<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title>
				<button type="button" class="btn-flat-icon--dark" @click="open=false">
					<v-icon large flat>fal fa-times</v-icon>
				</button>
				<v-spacer></v-spacer>
				<!-- <button type="button" class="btn-flat-icon--dark" @click="likeHost">
					<v-icon large flat>fal fa-heart</v-icon>
				</button> -->
			</v-card-title>
			<v-card-text class="pt-0 pl-4 pr-4 event-page__modal-card-text text-xs-center">
				<div>
					<div>
						<div class="event-page-host-container" style="margin-bottom: -16px;">
							<div class="host-divider">
							</div>
							<div class="white host-circle">
								<div :style="{'background-image': 'url(' + event.host.user.avatar + ')'}" class="host-image"></div>
							</div>
						</div>
					</div>
					<p class="event-page-content-light">
						<b>{{event.host.user.first_name}}</b>
					</p>
					<p class="event-page-content" style="padding: 0px 5%;">
						<span v-html="newlines(event.host.description)"></span>
					</p>
				</div>
				<div>
					<p class="event-page-sub-heading mt-3"><a @click="contactHostModal=true">Contact Host</a></p>
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
					<p class="event-page-sub-heading-small mb-3"><a @click="reportEventModal=true">Report this Location, Event, or Host</a></p>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { segmentTrack } from '~/plugins/segment'
import { replaceNewlines } from '~/store/util/util'

export default {
	name: 'eventHostModal',
	methods: {
		...mapActions([
			'setModalOpen'
		]),
		newlines(value) {
			return replaceNewlines(value)
		},
		likeHost() {
			segmentTrack('favorite_host', {
				label:
					this.event.host.user.first_name +
					' ' +
					this.event.host.user.last_name,
				value: this.event.host.pk
			})
		}
	},
	computed: {
		...mapGetters(['getModalProp']),
		open: {
			get() {
				return this.getModalProp('eventHostModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventHostModal', value: val })
			}
		},
		contactHostModal: {
			get() {
				return this.getModalProp('eventContactHostModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventContactHostModal', value: val })
			}
		},
		reportEventModal: {
			get() {
				return this.getModalProp('eventReportEventModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventReportEventModal', value: val })
			}
		},
		event() {
			return this.getModalProp('eventModalEvent')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
